export interface IUserSetting {
  key: string;
  value: unknown;
}
